/**
 * 学ぶ頁の群 (ガイド、技術面接の練習、面接問題、つまずき辞典、全レッスン一覧、職種別ガイド、大学向け、FDE) の頭に置く絵の帯 (字なし)。
 * 絵柄と寸法は学習パスの章の帯と同じ (2880x400 で組み、広い画面は 1240x172 まで、狭い画面は右の絵だけの版)。
 * 絵の正本は m6-briefs/vwork/art-pages-learn の build.mjs (全レッスン一覧、職種別ガイド、大学向け、FDE の 4 本は notes-sandbox/ops/art/learn-band/build.mjs。場面を中央に組むので、狭い画面は中央を切る)。名前に中身のハッシュが入る (public/assets は 1 年 immutable)。
 * 文言とリンクには触れない飾りなので読み上げには出さない。頁の頭の 1 枚なので先に読む。
 * 暗い版では章の帯と同じだけ明るさを抑える
 */
export const LEARN_ART_BANDS = {
  guides: { wide: "guides-ab0a1b18b9.webp", sp: "guides-sp-f4c5b56252.webp" },
  "learn-interview": { wide: "learn-interview-0a287df69d.webp", sp: "learn-interview-sp-c4a5df172d.webp" },
  "interview-questions": { wide: "interview-questions-27fc571ee2.webp", sp: "interview-questions-sp-c7605168be.webp" },
  mistakes: { wide: "mistakes-c94b1d7e66.webp", sp: "mistakes-sp-a43da5fb8d.webp" },
  lessons: { wide: "lessons-d0147ae7fb.webp", sp: "lessons-sp-b1398e2d75.webp" },
  career: { wide: "career-8369b25357.webp", sp: "career-sp-17cd528fdd.webp" },
  university: { wide: "university-c9d289549f.webp", sp: "university-sp-5841850454.webp" },
  fde: { wide: "fde-839f054631.webp", sp: "fde-sp-89aae3daf4.webp" },
  /* コーディング面接問題。正本は notes-sandbox/ops/art/learn-band/build.mjs の coding-interview (2026-10-24) */
  "coding-interview": { wide: "coding-interview-4dcd263e50.webp", sp: "coding-interview-sp-966db6bccc.webp" },
} as const;

export type LearnArtBandName = keyof typeof LEARN_ART_BANDS;

/** 広い画面の絵の住所 (PublicPageBand の帯の絵として使うため) */
export function learnArtBandSrc(name: LearnArtBandName): string {
  return `/assets/learn-art/${LEARN_ART_BANDS[name].wide}`;
}

export function LearnArtBand({ name, className = "" }: { name: LearnArtBandName; className?: string }) {
  const band = LEARN_ART_BANDS[name];
  return (
    <picture data-learn-art={name} className={`block ${className}`.trim()}>
      <source media="(max-width: 639px)" srcSet={`/assets/learn-art/${band.sp}`} width={760} height={205} />
      <img
        src={`/assets/learn-art/${band.wide}`}
        alt=""
        aria-hidden="true"
        width={2480}
        height={344}
        loading="eager"
        fetchPriority="high"
        className="block h-auto w-full rounded-[2px] [:root[data-theme=dark]_&]:brightness-[.82]"
      />
    </picture>
  );
}
